import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import styled, { useTheme } from 'styled-components'

import { FiMenu } from 'react-icons/fi';

import Flex from '../styleguide/layout/Flex'

import logo from "../../assets/logo.png"

// common components -- "./"
import Dropdown from "./Dropdown"
import NavigationLink from "./NavigationLink"

// layout components -- "../styleguide/layout"
import { Container } from '../styleguide/layout'



const Header = () => {

  const theme = useTheme();

  const [isOpen, setIsOpen] = React.useState(false);

  const closeMenu= () => setIsOpen(false);
  const [shouldStick, setShouldStick] = useState(false);

  // handle sticky header with changed background color
  useEffect(() => {
      window.addEventListener('scroll', isSticky);
      return () => {
          window.removeEventListener('scroll', isSticky);
      };
  });

  const isSticky = (e) => {
      const scrollTop = window.scrollY;
      console.log("scrollTop", scrollTop);
      scrollTop >= 23 ? setShouldStick(true) : setShouldStick(false);
  };

  return (
    <Container  position="fixed" top="0" left="50%" transform="translateX(-50%)" bg={shouldStick ? theme.colors.white : "none"} zIndex="5">
      <Flex padding="1.5rem 0" items="center" justifyMobile="space-between">
        <StyledLink style={{ width: "40%" }} to="/">
          <Logo src={logo} alt="logo" />
        </StyledLink>

        {
          isOpen && (
            <Overlay onClick={() => closeMenu()} />
          )
        }

        <NavMenu className={isOpen ? "active" : ""}>
          <NavigationLink onClick={() => closeMenu()} to="/">Home</NavigationLink>
          <NavigationLink onClick={() => closeMenu()} to="about">About</NavigationLink>
          <Dropdown closeMenu={closeMenu} />
          <NavigationLink onClick={() => closeMenu()} to="mula-token">Mula Token</NavigationLink>
          <NavigationLink onClick={() => closeMenu()} to="faqs">FAQS</NavigationLink>
        </NavMenu>

        <MobileToggler onClick={() => setIsOpen(!isOpen)} />
      </Flex>
    </Container>
  )
}

export default Header

const StyledLink = styled(Link)`
  width: 40%;

  @media (max-width: 768px) {
    width: auto;
  }
`

const Logo = styled.img`
  height: 3.5rem;
  width: auto;
`

const Overlay = styled.div`
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 1;
`

const NavMenu = styled.nav`
  display: flex;
  align-items: center;
  gap: 2rem;

  @media (max-width: 768px) {
    display: none;

    &.active {
      position: fixed;
      right: 0;
      top: 0;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      width: 250px;
      height: 100vh;
      background-color: ${({ theme }) => theme.colors.white};
      padding: 2rem;
      z-index: 2;
    }
  }
`

const MobileToggler = styled(FiMenu)`
  font-size: 2rem;
  color: ${({ theme }) => theme.colors.primary};
  cursor: pointer;
  display: none;

  @media (max-width: 768px) {
    display: block;
  }
`